export default __webpack_public_path__ + "static/media/black-flower.ec832e2c.png";